module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('p', {
    staticClass: "ded-title"
  }, [_c('b', [_vm._v("DEDICATION")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Over the past 28 years, the Brooklyn Quilters Guild has been a constant source of support and inspiration for me. I happened upon their first guild show and realized not only that I had found my medium but that there was a group of people with a shared interest that I could be part of.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The guild started in 1993 with just 30 members, has now grown to about 200 members and is as diverse as Brooklyn itself.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The volunteers of guilds around the country organize meetings and quilt shows, write the newsletters, and make the many charity quilts. Most of all, they help keep the art of quilting alive so that it can be enjoyed by everyone.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This book is dedicated to the Brooklyn Guild and the many volunteers who over the years have made the guild what it is today.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75a738ec","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/04_ded.vue
// module id = 63
// module chunks = 0